import { render, staticRenderFns } from "./widgetBody.vue?vue&type=template&id=db3c693e&scoped=true"
import script from "./widgetBody.vue?vue&type=script&lang=js"
export * from "./widgetBody.vue?vue&type=script&lang=js"
import style0 from "./widgetBody.vue?vue&type=style&index=0&id=db3c693e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db3c693e",
  null
  
)

export default component.exports